import { defineComponent, onMounted, openBlock, createElementBlock, createElementVNode, createVNode, unref, withCtx, createTextVNode } from "vue";
import { IconChat, CdrButton } from "@rei/cedar";
const _hoisted_1 = {
  class: "expertise-chat__container"
};
const _hoisted_2 = {
  class: "expertise-chat__img-container"
};
const _hoisted_3 = {
  class: "expertise-chat__icon"
};
const _hoisted_4 = {
  class: "expertise-chat__information"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ExpertiseChatV1",
  emits: ["cta-clicked", "initGladlyChat", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const onCtaClicked = () => {
      emit("cta-clicked");
      emit("metricsClick", {
        linkName: "help:sidekick_open_startchatnow"
      });
    };
    onMounted(() => {
      emit("initGladlyChat");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = createElementVNode("img", {
        class: "expertise-chat__img",
        src: "https://public.cloud-dam.rei.com/api/public/content/f9f2a982d54d4991b67be83d8dfbb709",
        alt: "image of a girl hiking in iceland"
      }, null, -1)), createElementVNode("div", _hoisted_3, [createVNode(unref(IconChat), {
        "inherit-color": ""
      })])]), createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = createElementVNode("h2", {
        class: "expertise-chat__header"
      }, " Need help choosing gear? ", -1)), _cache[3] || (_cache[3] = createElementVNode("text", {
        class: "expertise-chat__text"
      }, " Get real advice from our experts who have been there, done that. ", -1)), createVNode(unref(CdrButton), {
        "data-testid": "expertise-chat-button",
        modifier: "primary",
        class: "expertise-chat__button",
        onClick: onCtaClicked
      }, {
        default: withCtx(() => [createVNode(unref(IconChat), {
          class: "expertise-chat__button--icon"
        }), _cache[1] || (_cache[1] = createTextVNode(" Start chat now "))]),
        _: 1,
        __: [1]
      })])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ExpertiseChatV12.mjs.map
